export default __webpack_public_path__ + "97fed005a25b6493f1d223d7da0a75dd.png";